(function(){
  // Zelfde weergave als Shopify zelf: bedrag zonder euroteken.
  var money = function(cents){ return (cents/100).toFixed(2).replace('.', ','); };
  var $ = function(s,r){ return (r||document).querySelector(s); };
  var $$ = function(s,r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); };
  // Teksten in de taal van de bezoeker; window.T wordt gevuld door snippets/js-strings.liquid.
  var t = function(k, v){
    var s = (window.T && window.T[k]) || '';
    if (v) { for (var x in v) { s = s.split('{' + x + '}').join(v[x]); } }
    return s;
  };
  var esc = function(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); };

  /* ---------- mobiel menu ---------- */
  function zetMenu(open){
    var menu = $('#MobileMenu'), knop = $('[data-menu-open]');
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    document.body.classList.toggle('menu-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
    if (knop) knop.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  document.addEventListener('click', function(e){
    if (e.target.closest('[data-menu-open]')) zetMenu(true);
    else if (e.target.closest('[data-menu-close]')) zetMenu(false);
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && document.body.classList.contains('menu-open')) zetMenu(false);
  });

  /* ---------- cart drawer ---------- */
  function injectExpress(el){
    var tpl = el && el.querySelector('template');
    if (!tpl) return;
    el.appendChild(tpl.content.cloneNode(true));
    tpl.remove();
  }
  function openCart(){
    document.body.classList.add('drawer-open');
    // Snelle betaalknoppen alleen op de computer: op de telefoon toont het mandje alleen producten en afrekenen.
    if (!window.matchMedia('(max-width: 860px)').matches) injectExpress($('[data-defer-express="drawer"]'));
    zetPil();
  }
  function closeCart(){ document.body.classList.remove('drawer-open'); zetPil(); }

  function renderCart(cart){
    var count = cart.item_count;
    $$('[data-cart-count]').forEach(function(el){
      el.textContent = count;
      el.setAttribute('data-filled', count > 0 ? 'true' : 'false');
    });
    var body = $('[data-cart-body]');
    if (!body) return;
    if (!count) {
      body.innerHTML = $('#CartEmptyTemplate').innerHTML;
      $('[data-cart-foot]').hidden = true;
      $('[data-cart-note]').hidden = true;
      $('[data-cart-meer]').hidden = true;
      var leeg = $('[data-mandje-pil]');
      if (leeg) { leeg.setAttribute('data-aantal', '0'); zetPil(); }
      return;
    }
    $('[data-cart-foot]').hidden = false;
    $('[data-cart-note]').hidden = false;
    $('[data-cart-meer]').hidden = false;
    var html = cart.items.map(function(it){
      var cadeau = it.properties && it.properties._cadeau;
      return '<div class="line">' +
        '<img src="' + (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '') + '" alt="' + esc(it.product_title) + '" width="68" height="68">' +
        '<div style="flex:1;min-width:0;display:flex;flex-direction:column;gap:4px">' +
          '<span class="line__name">' + esc(String(it.product_title).split(' - TheWootz')[0]) + '</span>' +
          '<span class="line__meta">' + (it.variant_title && it.variant_title !== 'Default Title' ? esc(it.variant_title.indexOf('%') > -1 ? it.variant_title.split(' (')[0] : it.variant_title) : '') + '</span>' +
          (it.selling_plan_allocation ? '<span class="line__meta line__plan">' + esc(it.selling_plan_allocation.selling_plan.name) + '</span>' : '') +
          (cadeau ? '<span class="line__meta line__cadeau">' + esc(t('gift_label')) + '</span>' : '') +
          '<div class="row gap-10" style="margin-top:4px">' +
            (cadeau ? '' : '<div class="qty qty--sm"><button type="button" data-line-change="' + it.key + '" data-qty="' + (it.quantity - 1) + '" aria-label="' + esc(t('qty_less')) + '">\u2212</button>' +
            '<input type="text" value="' + it.quantity + '" readonly aria-label="' + esc(t('qty')) + '">' +
            '<button type="button" data-line-change="' + it.key + '" data-qty="' + (it.quantity + 1) + '" aria-label="' + esc(t('qty_more')) + '">+</button></div>') +
            '<button type="button" class="small" style="text-decoration:underline" data-line-change="' + it.key + '" data-qty="0">' + esc(t('remove')) + '</button>' +
          '</div>' +
        '</div>' +
        '<span class="line__price">' + (it.original_line_price > it.final_line_price ? '<s class="line__was">' + money(it.original_line_price) + '</s> ' : '') + money(it.final_line_price) + '</span>' +
      '</div>';
    }).join('');
    // Plank met onderhoudsset in het mandje: geen tweede set aanraden (Julian 30-10-2026).
    var upsell = $(plankMetSet(cart) ? '#CartUpsellSetTemplate' : '#CartUpsellTemplate');
    if (upsell) {
      var upsellId = upsell.getAttribute('data-upsell-id');
      var alreadyIn = cart.items.some(function(i){ return String(i.product_id) === String(upsellId); });
      // Alleen bij een plank in het mandje (thema-instelling); zonder die instelling altijd.
      var triggers = (upsell.getAttribute('data-trigger-ids') || '').split(',').filter(Boolean);
      var triggered = !triggers.length || cart.items.some(function(i){ return triggers.indexOf(String(i.product_id)) > -1; });
      if (!alreadyIn && triggered) html += upsell.innerHTML;
    }
    body.innerHTML = html;
    $('[data-cart-total]').textContent = money(cart.total_price);
    var pil = $('[data-mandje-pil]');
    if (pil) { pil.setAttribute('data-aantal', cart.item_count); var pt = $('[data-mandje-pil-totaal]', pil); if (pt) pt.textContent = money(cart.total_price); }
    var knopTotaal = $('[data-cart-total-knop]');
    if (knopTotaal) knopTotaal.textContent = money(cart.total_price);
    var verz = $('[data-cart-verzending]');
    if (verz) {
      var gratis = cart.total_price >= (parseInt(verz.getAttribute('data-free-from'), 10) || 0);
      verz.textContent = gratis ? verz.getAttribute('data-free-text') : verz.getAttribute('data-fee');
    }
    // Boven de 23 kg past het niet in een pakket en rekent Shopify geen tarief:
    // dan de klant naar de offerte wijzen in plaats van hem laten vastlopen.
    var bulk = $('[data-bulk-note]');
    if (bulk) bulk.hidden = cart.total_weight < (parseInt(bulk.getAttribute('data-bulk-grams'), 10) || 23000);
    zetGratisVerzending(cart);
    toonSetAanbod(cart);
  }

  /* ---------- slimme sets in het mandje ----------
     Drie soorten aanbod, de grootste besparing wint:
     - compleet: er mist nog één onderdeel van een set (geen olie: die maat kiest de klant zelf).
       De klant ziet wat dat onderdeel nog kost: de setprijs min wat de rest nu kost.
     - omzetten: alle onderdelen zitten er los in; als set betaal je minder.
     - korting: onderhoud waar geen set bij past; dan het product uit de thema-instelling met korting
       (die korting moet in Shopify als automatische korting bestaan).
     Gegevens komen uit sections/cart-sets.liquid. */
  var setGegevens = null;
  function laadSets(){
    if (setGegevens !== null) return Promise.resolve(setGegevens);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + '?sections=cart-sets').then(function(r){ return r.json(); }).then(function(j){
      var div = document.createElement('div');
      div.innerHTML = j['cart-sets'] || '';
      var el = div.querySelector('[data-cart-sets]');
      setGegevens = el ? JSON.parse(el.textContent) : false;
      return setGegevens;
    }).catch(function(){ setGegevens = false; return false; });
  }

  // Herkenning van de uitvoering met set, in alle talen: zelfde woorden als in sections/cart-sets.liquid.
  function plankMetSet(cart){
    return cart.items.some(function(it){ return /onderhoud|care|pflege/i.test(it.variant_title || ''); });
  }

  function kiesSetAanbod(cart, d, c){
    if (!d || !d.on) return null;
    // De plank met set heeft alles al: ook na een los product erbij geen set of doekkorting meer aanbieden.
    if (plankMetSet(cart)) return null;
    // Losse regels per product: alleen de variant van 1 stuk, geen abonnement, niet het cadeau. De prijs is wat
    // de klant nu echt betaalt, na kortingen als de doek voor de halve prijs of 'Stel zelf samen'; anders belooft het
    // mandje een besparing die er niet is (5,90 terwijl het 1,43 was, 28-10-2026).
    var los = {};
    cart.items.forEach(function(it){
      if (it.properties && it.properties._cadeau) return;
      var deel = d.parts[it.product_id];
      if (!deel || it.selling_plan_allocation || String(it.variant_id) !== String(deel.v) || los[it.product_id]) return;
      los[it.product_id] = { key: it.key, qty: it.quantity, prijs: Math.round(it.final_line_price / it.quantity) };
    });
    // Korting die een los product nu heeft. Wat na het omzetten los overblijft, kan die korting verliezen (de doek
    // voor de halve prijs naast een set); we rekenen dat als verloren, zodat het mandje nooit te veel belooft.
    var korting = {}, totKorting = 0;
    Object.keys(los).forEach(function(pid){ korting[pid] = Math.max(0, d.parts[pid].p - los[pid].prijs); totKorting += korting[pid]; });
    var behoud = function(weg){ return weg.reduce(function(a, pid){ return a + korting[pid]; }, 0); };
    var kandidaten = [];
    d.sets.forEach(function(set){
      var kloppen = set.parts.every(function(pid){ return d.parts[pid]; });
      if (!kloppen) return;
      // Krijgt de klant het cadeau gratis, dan geen set voorstellen waar hij ervoor betaalt (en die het cadeau laat vervallen).
      if (c && c.geldig && set.parts.indexOf(c.g.product) > -1) return;
      var erin = set.parts.filter(function(pid){ return los[pid]; });
      var mist = set.parts.filter(function(pid){ return !los[pid]; });
      if (!erin.length) return;
      var nu = erin.reduce(function(a, pid){ return a + los[pid].prijs; }, 0);
      var verlies = totKorting - behoud(erin);
      var kandidaat = null;
      if (mist.length === 1 && !d.parts[mist[0]].oil) {
        var deel = d.parts[mist[0]];
        kandidaat = { soort: 'compleet', set: set, deel: deel, extra: set.p - nu + verlies, winst: nu + deel.p - set.p - verlies, weg: erin };
      } else if (!mist.length) {
        kandidaat = { soort: 'omzetten', set: set, basis: nu - set.p, winst: nu - set.p - verlies, weg: erin };
      }
      // Minder dan een euro voordeel is geen aanbod waard (olie 20 ml, bijenwas en doek gaf 'bespaar 0,03').
      if (kandidaat && kandidaat.winst >= 100) kandidaten.push(kandidaat);
    });
    // Eerst omzetten wat de klant al los heeft. Een set aanvullen mag geen product weghalen uit een set die de
    // losse producten samen al vormen: olie, bijenwas en doek los werd anders 'bijenwas met applicator' en de
    // complete set viel uit elkaar (Julian 28-10-2026). Passen er meer sets, dan telt de grootste besparing samen.
    var omzet = besteOmzetting(kandidaten.filter(function(k){ return k.soort === 'omzetten'; }), totKorting, behoud);
    var bezet = {};
    omzet.forEach(function(k){ k.weg.forEach(function(pid){ bezet[pid] = true; }); });
    var beste = null;
    kandidaten.forEach(function(k){
      if (k.soort === 'omzetten' ? omzet.indexOf(k) < 0 : k.weg.some(function(pid){ return bezet[pid]; })) return;
      if (!beste || k.winst > beste.winst || (k.winst === beste.winst && k.soort === 'compleet')) beste = k;
    });
    if (beste) { beste.los = los; return beste; }
    // Een plank zonder set in het mandje: de uitvoering met onderhoudsset (de plank wordt omgezet).
    var plankAanbod = null;
    cart.items.some(function(it){
      var b = d.boards && d.boards[it.product_id];
      if (!b || String(it.variant_id) !== String(b.plank) || it.selling_plan_allocation) return false;
      plankAanbod = { soort: 'plankset', b: b, extra: b.setP - b.plankP, winst: b.winst, regel: { key: it.key, qty: it.quantity } };
      return true;
    });
    if (plankAanbod) return plankAanbod;
    // Geen set: korting op het aanbod, als er onderhoud in zit en het aanbod (of een set ermee) er nog niet in zit.
    var o = d.offer || null;
    if (!o) return kiesGroter(cart, d);
    var heeftZorg = cart.items.some(function(it){ var x = d.parts[it.product_id]; return x && x.care && String(it.product_id) !== String(o.product); });
    var heeftAanbod = cart.items.some(function(it){
      if (String(it.product_id) === String(o.product)) return true;
      return d.sets.some(function(set){ return String(set.v) === String(it.variant_id) && set.parts.indexOf(o.product) > -1; });
    });
    // Heeft de klant recht op het cadeau, dan niet: de doekkorting gaat in Shopify niet samen met het cadeau
    // en zou vervallen zodra het cadeau erbij komt.
    if (heeftZorg && !heeftAanbod && !(c && (c.geldig || c.regel))) {
      var korting = Math.floor(o.p * o.pct / 100); // Shopify rondt de korting per regel naar beneden af
      return { soort: 'korting', offer: o, prijs: o.p - korting, winst: korting };
    }
    return kiesGroter(cart, d);
  }

  // Een set net onder de grens voor gratis verzending: de eerstvolgende maat die er wel overheen gaat. Op 30-10 deed
  // een klant dit zelf (van 19,95 naar 25,95), op 1-11 bleef een klant op 19,95 plus verzending (Julian 1-11-2026).
  function kiesGroter(cart, d){
    var balk = $('[data-free-ship]');
    var vanaf = balk ? parseInt(balk.getAttribute('data-free-from'), 10) || 0 : 0;
    if (!vanaf || cart.total_price >= vanaf) return null;
    var beste = null;
    cart.items.forEach(function(it){
      if (it.quantity !== 1 || it.selling_plan_allocation) return;
      var nu = d.sets.filter(function(s){ return String(s.v) === String(it.variant_id) && s.fam > -1; })[0];
      if (!nu) return;
      d.sets.forEach(function(s){
        if (s.fam !== nu.fam || s.p <= nu.p) return;
        var extra = s.p - it.final_line_price;
        if (extra > 1000 || cart.total_price + extra < vanaf) return;
        if (!beste || extra < beste.extra) beste = { soort: 'groter', set: s, van: nu, extra: extra, winst: 0, weg: [] };
      });
    });
    return beste;
  }

  // Sets zonder gedeelde producten met samen de grootste besparing (het zijn er hooguit een handvol). Korting op
  // wat daarna nog los in het mandje zit, telt als verloren.
  function besteOmzetting(lijst, totKorting, behoud){
    var beste = [], max = 0;
    (function zoek(i, gekozen, bezet, som){
      var score = som - (totKorting - behoud(Object.keys(bezet)));
      if (gekozen.length && score > max) { max = score; beste = gekozen.slice(); }
      for (var j = i; j < lijst.length && j < 12; j++) {
        var k = lijst[j];
        if (k.weg.some(function(pid){ return bezet[pid]; })) continue;
        var nb = Object.assign({}, bezet);
        k.weg.forEach(function(pid){ nb[pid] = true; });
        zoek(j + 1, gekozen.concat([k]), nb, som + k.basis);
      }
    })(0, [], {}, 0);
    return beste;
  }

  function setAanbodHtml(a){
    var plaatje = function(src, alt){ return src ? '<img src="' + esc(src) + '" alt="' + esc(alt) + '" width="56" height="56" loading="lazy">' : ''; };
    var badge = '<span class="voordeel-badge voordeel-badge--klein">' + esc(t('save_amount', { bedrag: money(a.winst) })) + '</span>';
    var kop, beeld, naam, regel, knop;
    if (a.soort === 'plankset') {
      kop = t('sheet_plank_title');
      beeld = plaatje(a.b.img, a.b.t); naam = a.b.t;
      regel = '<span class="set-aanbod__prijs">+ ' + money(a.extra) + '</span>' + '<span class="small">' + esc(window.TheWootzBoardText || '') + '</span>';
      knop = t('add_for', { bedrag: money(a.extra) });
      if (a.winst <= 0) badge = '';
    } else if (a.soort === 'compleet') {
      kop = t('set_complete_eyebrow');
      beeld = plaatje(a.deel.img, a.deel.t); naam = a.deel.t;
      regel = '<span class="set-aanbod__prijs">' + esc(t('set_complete_price', { bedrag: money(a.extra) })) + ' <s>' + money(a.deel.p) + '</s></span>' +
              '<span class="small">' + esc(t('set_complete_note', { set: a.set.t })) + '</span>';
      knop = t('add_for', { bedrag: money(a.extra) });
    } else if (a.soort === 'omzetten') {
      kop = t('set_swap_eyebrow');
      beeld = plaatje(a.set.img, a.set.t); naam = a.set.t;
      regel = '<span class="small">' + esc(t('set_swap_note', { bedrag: money(a.winst) })) + '</span>';
      knop = t('set_swap_button');
    } else if (a.soort === 'groter') {
      kop = t('groter_eyebrow');
      beeld = plaatje(a.set.img, a.set.t); naam = a.set.t;
      regel = '<span class="set-aanbod__prijs">+ ' + money(a.extra) + '</span>' +
              '<span class="small">' + esc(t('groter_note', { nieuw: a.set.m, nu: a.van.m, kosten: setGegevens.fee })) + '</span>';
      knop = t('groter_knop', { bedrag: money(a.extra) });
      badge = '';
    } else {
      kop = a.offer.pct === 50 ? t('offer_eyebrow_half') : t('offer_eyebrow_pct', { pct: a.offer.pct });
      beeld = plaatje(a.offer.img, a.offer.t); naam = a.offer.t;
      regel = '<span class="set-aanbod__prijs">' + money(a.prijs) + ' <s>' + money(a.offer.p) + '</s></span>' +
              (a.offer.text ? '<span class="small">' + esc(a.offer.text) + '</span>' : '');
      knop = t('add_for', { bedrag: money(a.prijs) });
    }
    return '<div class="set-aanbod" data-set-aanbod-blok>' +
      '<div class="row" style="justify-content:space-between;align-items:center;gap:8px"><span class="eyebrow" style="font-size:19px">' + esc(kop) + '</span>' + badge + '</div>' +
      '<div class="set-aanbod__rij">' + beeld + '<div class="set-aanbod__tekst"><span class="set-aanbod__naam">' + esc(naam) + '</span>' + regel + '</div></div>' +
      '<button type="button" class="btn btn--primary btn--sm btn--full" data-set-aanbod-knop>' + esc(knop) + '</button>' +
    '</div>';
  }

  /* ---------- cadeau bij olie (Julian, 28-10-2026) ----------
     Vanaf een bedrag aan olie (alles waar olie in zit) biedt het mandje het cadeau aan: de applicator.
     De klant voegt hem zelf toe met een klik, we stoppen niets in het mandje dat hij niet wil.
     Shopify maakt hem gratis met een automatische korting 'Koop X, krijg Y' met hetzelfde bedrag.
     Zit er een set met applicator in het mandje, dan vervalt het cadeau. Zakt het bedrag onder de grens,
     dan gaat het cadeau er weer uit, anders zou de klant er de volle prijs voor betalen.
     Abonnementen en kortingen tellen niet mee: we rekenen met wat de klant echt betaalt, zodat het mandje
     nooit een cadeau belooft dat Shopify niet geeft. Gegevens komen uit sections/cart-sets.liquid. */
  function cadeauStaat(cart, d){
    var g = d && d.gift;
    if (!g || !cart.item_count) return null;
    var olie = 0, regel = null, metSet = false, los = false, verlies = 0;
    cart.items.forEach(function(it){
      if (it.properties && it.properties._cadeau) { regel = it; return; }
      // Het cadeau gaat in Shopify niet samen met andere productkortingen ('Stel zelf samen', de doek voor de halve
      // prijs): Shopify geeft de korting die de klant het meest oplevert. Wat er nu aan korting op zit, vervalt dus
      // als het cadeau erbij komt (Basic-abonnement, getest 29-10-2026).
      if (!it.selling_plan_allocation) verlies += it.line_level_total_discount != null ? it.line_level_total_discount : Math.max(0, it.original_line_price - it.final_line_price);
      if (String(it.product_id) === String(g.product)) los = true;
      if (g.metCadeau.indexOf(it.product_id) > -1) metSet = true;
      if (g.olie.indexOf(it.product_id) > -1 && !it.selling_plan_allocation) olie += it.final_line_price;
    });
    var geldig = olie >= g.drempel && !metSet;
    return {
      g: g, olie: olie, rest: g.drempel - olie, geldig: geldig, regel: regel, verlies: verlies,
      // Kost de cadeauregel toch geld (Shopify vond een andere korting voordeliger), dan gaat hij er meteen uit.
      weg: !!regel && (!geldig || regel.final_line_price > 0),
      // Alleen aanbieden als het cadeau meer oplevert dan de korting die er nu op zit; anders geeft Shopify het niet.
      aanbod: geldig && !regel && !los && verlies < g.p,
      // Op weg naar het cadeau: pas vanaf de helft, zodat het geen vaste reclameregel wordt.
      voortgang: !geldig && !metSet && !regel && olie > 0 && olie * 2 >= g.drempel
    };
  }
  function cadeauHtml(c){
    if (!c) return '';
    if (c.aanbod) return '<div class="set-aanbod" data-cadeau-blok>' +
      '<div class="row" style="justify-content:space-between;align-items:center;gap:8px"><span class="eyebrow" style="font-size:19px">' + esc(t('gift_eyebrow')) + '</span><span class="voordeel-badge voordeel-badge--klein">' + esc(t('gift_free')) + '</span></div>' +
      '<div class="set-aanbod__rij">' + (c.g.img ? '<img src="' + esc(c.g.img) + '" alt="' + esc(c.g.t) + '" width="56" height="56" loading="lazy">' : '') +
        '<div class="set-aanbod__tekst"><span class="set-aanbod__naam">' + esc(c.g.t) + '</span>' +
        '<span class="set-aanbod__prijs">' + esc(t('gift_free')) + ' <s>' + money(c.g.p) + '</s></span>' +
        '<span class="small">' + esc(t('gift_note', { drempel: c.g.drempel % 100 ? money(c.g.drempel) : String(c.g.drempel / 100) })) + '</span>' + cadeauVerlies(c) + '</div></div>' +
      '<button type="button" class="btn btn--primary btn--sm btn--full" data-cadeau-knop>' + esc(t('gift_button')) + '</button>' +
    '</div>';
    if (c.voortgang) return '<p class="cadeau-voortgang" data-cadeau-blok>' + esc(t('gift_progress', { bedrag: money(c.rest) })) + '</p>';
    return '';
  }
  function cadeauVerlies(c){
    return c.verlies ? '<span class="small">' + esc(t('gift_offer_lost', { bedrag: money(c.verlies) })) + '</span>' : '';
  }
  function velCadeauHtml(c){
    return '<div class="toegevoegd__aanbod">' +
      '<span class="toegevoegd__vlag">' + esc(t('gift_flag')) + '</span>' +
      (c.g.img ? '<img src="' + esc(c.g.img) + '" alt="" width="64" height="64">' : '') +
      '<div class="toegevoegd__tekst"><span class="toegevoegd__naam">' + esc(c.g.t) + '</span><span class="toegevoegd__sub">' + esc(t('gift_note', { drempel: c.g.drempel % 100 ? money(c.g.drempel) : String(c.g.drempel / 100) })) + '</span>' + cadeauVerlies(c) + '</div>' +
      '<button type="button" class="toegevoegd__plus" data-cadeau-knop>' + esc(t('gift_button')) + '</button>' +
    '</div>';
  }
  // Op de mandjespagina staan de regels in Liquid: dan de pagina opnieuw laden.
  function naCadeauWijziging(){
    var b = document.body.classList;
    if ($('[data-set-aanbod-plek]') && !b.contains('drawer-open') && !b.contains('toegevoegd-open')) { location.reload(); return null; }
    return fetchCart();
  }
  function haalCadeauWeg(regel){
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: regel.key, quantity: 0 }) })
      .then(naCadeauWijziging).catch(function(){});
  }
  document.addEventListener('click', function(e){
    var knop = e.target.closest('[data-cadeau-knop]');
    if (!knop || knop.disabled) return;
    e.preventDefault();
    var label = knop.textContent, inVel = !!knop.closest('[data-toegevoegd]');
    knop.disabled = true; knop.textContent = t('please_wait');
    laadSets().then(function(d){
      if (!d || !d.gift) throw new Error(t('add_failed'));
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: d.gift.v, quantity: 1, properties: { _cadeau: '1' } }] }) });
    }).then(function(r){
      if (!r.ok) throw new Error(t('add_failed'));
      if (typeof window.clarity === 'function') window.clarity('event', 'cadeau_applicator');
      if (inVel) $('[data-toegevoegd-aanbod]').innerHTML = '<div class="toegevoegd__bespaard">' + esc(t('gift_added')) + '</div>';
      return naCadeauWijziging();
    }).catch(function(){
      knop.textContent = t('failed_short');
      setTimeout(function(){ knop.textContent = label; knop.disabled = false; }, 2200);
    });
  });

  var huidigAanbod = null;
  function toonSetAanbod(cart){
    var plekken = $$('[data-set-aanbod-plek]');
    var lade = $('[data-cart-body]');
    if (!plekken.length && !lade) return;
    laadSets().then(function(d){
      if (d && d.boardText) window.TheWootzBoardText = d.boardText;
      var c = cadeauStaat(cart, d);
      if (c && c.weg) { haalCadeauWeg(c.regel); return; }
      huidigAanbod = cart.item_count ? kiesSetAanbod(cart, d, c) : null;
      var html = huidigAanbod ? setAanbodHtml(huidigAanbod) : '';
      var cadeau = cadeauHtml(c);
      plekken.forEach(function(p){ p.innerHTML = cadeau + html; });
      if (lade) {
        var oud = $('[data-set-aanbod-blok]', lade);
        if (oud) oud.remove();
        var oudCadeau = $('[data-cadeau-blok]', lade);
        if (oudCadeau) oudCadeau.remove();
        if (html) {
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var upsell = $('.upsell', lade);
          // Plank met set aangeboden: dan de losse aanbeveling (onderhoudspakket) niet ook nog.
          if (huidigAanbod.soort === 'plankset' && upsell) { upsell.remove(); upsell = null; }
          lade.insertBefore(tmp.firstChild, upsell || null);
        }
        if (cadeau) {
          var tmpC = document.createElement('div'); tmpC.innerHTML = cadeau;
          lade.insertBefore(tmpC.firstChild, $('[data-set-aanbod-blok]', lade) || $('.upsell', lade) || null);
        }
      }
    });
  }

  function voerSetAanbodUit(knop){
    var a = huidigAanbod;
    if (!a) return Promise.resolve(null);
    knop.disabled = true;
    knop.textContent = t('please_wait');
    var post = function(url, body){
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw new Error(j.description || j.message || t('add_failed')); return j; }); });
    };
    var haal = function(){ return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function(r){ return r.json(); }); };
    var nieuw = a.soort === 'korting' ? a.offer.v : (a.soort === 'plankset' ? a.b.set : a.set.v);
    // Welke losse varianten er (één stuk) uit moeten zodra de set erin zit.
    var wegV = (a.weg || []).map(function(pid){ return String(setGegevens.parts[pid].v); });
    if (a.soort === 'plankset') wegV.push(String(a.b.plank));
    if (a.soort === 'groter') wegV.push(String(a.van.v));
    // Eerst toevoegen: lukt dat niet (uitverkocht), dan blijft het mandje zoals het was.
    var stap = post('/cart/add.js', { items: [{ id: nieuw, quantity: 1 }] }).then(function(j){ meldMandje(); return j; });
    if (wegV.length) stap = stap.then(function(){
      // De regels opnieuw opzoeken en in één keer aanpassen: Shopify geeft een regel een nieuwe sleutel
      // zodra er een korting bij komt of afgaat, dus de sleutels van voor het toevoegen kloppen niet meer.
      return haal().then(function(cart){
        var updates = {}, n = 0;
        wegV.forEach(function(v){
          var r = cart.items.filter(function(it){ return String(it.variant_id) === v && !it.selling_plan_allocation; })[0];
          if (r) { updates[r.key] = r.quantity - 1; n++; }
        });
        if (n !== wegV.length) throw new Error(t('add_failed'));
        return post('/cart/update.js', { updates: updates });
      }).catch(function(err){
        // Terugdraaien: de set er weer uit, zodat niemand de losse producten en de set allebei betaalt.
        return haal().then(function(c2){
          var r = c2.items.filter(function(it){ return String(it.variant_id) === String(nieuw); })[0];
          return r ? post('/cart/change.js', { id: r.key, quantity: r.quantity - 1 }) : null;
        }).catch(function(){}).then(function(){ throw err; });
      });
    });
    return stap.then(function(){
      if (a.soort === 'groter' && typeof window.clarity === 'function') window.clarity('event', 'maat_omhoog');
      var b = document.body.classList;
      if ($('[data-set-aanbod-plek]') && !b.contains('drawer-open') && !b.contains('toegevoegd-open')) { location.reload(); return null; }
      return fetchCart();
    }).catch(function(err){
      knop.disabled = false;
      knop.textContent = t('failed_short');
      knop.title = err.message;
      fetchCart();
      return null;
    });
  }
  document.addEventListener('click', function(e){
    var k = e.target.closest('[data-set-aanbod-knop]');
    if (k) { e.preventDefault(); voerSetAanbodUit(k); }
  });
  if ($('[data-set-aanbod-plek]')) fetch('/cart.js').then(function(r){ return r.json(); }).then(toonSetAanbod);

  // Gratis verzending vanaf een bedrag (snippets/free-shipping-bar): tekst en balkje bijwerken.
  function zetGratisVerzending(cart){
    $$('[data-free-ship]').forEach(function(el){
      var vanaf = parseInt(el.getAttribute('data-free-from'), 10) || 0;
      if (!vanaf) return;
      var rest = vanaf - cart.total_price;
      el.classList.toggle('is-free', rest <= 0);
      var tekst = $('[data-free-ship-text]', el);
      if (tekst) tekst.textContent = rest > 0 ? t('free_progress', { bedrag: money(rest) }) : t('free_reached');
      var vulling = $('[data-free-ship-fill]', el);
      if (vulling) vulling.style.width = Math.min(100, Math.round(cart.total_price / vanaf * 100)) + '%';
    });
  }

  function fetchCart(){ return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){ renderCart(c); return c; }); }

  // Microsoft Clarity herkent onze knoppen 'In mandje' niet zelf (Nederlandse tekst, toevoegen zonder nieuwe pagina);
  // daarom meldt het thema elke toevoeging als gebeurtenis add_to_cart.
  function meldMandje(){ if (typeof window.clarity === 'function') window.clarity('event', 'add_to_cart'); }

  function addToCart(items){
    return fetch('/cart/add.js', {
      method: 'POST', headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ items: items })
    }).then(function(r){
      return r.json().then(function(d){ if (!r.ok) { throw new Error(d.description || d.message || t('add_failed')); } return d; });
    }).then(function(d){
      meldMandje();
      return fetchCart().then(function(cart){ naToevoegen(d, cart); });
    });
  }

  /* ---------- na toevoegen: telefoon het venster 'Toegevoegd', computer het mandje ---------- */
  var mobiel = function(){ return window.matchMedia('(max-width: 860px)').matches; };
  function naToevoegen(d, cart){
    if (mobiel() && $('[data-toegevoegd]')) toonToegevoegd((d && d.items) || [], cart);
    else openCart();
  }
  function beeldKlein(src){ return src ? src.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : ''; }
  function toonToegevoegd(items, cart){
    var vel = $('[data-toegevoegd]');
    var it = items[0] || cart.items[0];
    if (!it) { openCart(); return; }
    var sub = it.variant_title && it.variant_title !== 'Default Title' ? (it.variant_title.indexOf('%') > -1 ? it.variant_title.split(' (')[0] : it.variant_title) : '';
    if (items.length > 1) {
      // Een hele bundel tegelijk: het aantal, de namen en samen de prijs.
      var namen = items.map(function(x){ return String(x.product_title).split(' - TheWootz')[0]; }).join(', ');
      var som = items.reduce(function(a, x){ return a + (x.final_line_price || x.price * (x.quantity || 1)); }, 0);
      $('[data-toegevoegd-item]', vel).innerHTML =
        (it.image ? '<img src="' + esc(beeldKlein(it.image)) + '" alt="" width="64" height="64">' : '') +
        '<div class="toegevoegd__tekst"><span class="toegevoegd__naam">' + esc(t('bb_count', { n: items.length })) + '</span><span class="toegevoegd__sub">' + esc(namen) + '</span></div>' +
        '<span class="toegevoegd__prijs">' + money(som) + '</span>';
    } else
    $('[data-toegevoegd-item]', vel).innerHTML =
      (it.image ? '<img src="' + esc(beeldKlein(it.image)) + '" alt="" width="64" height="64">' : '') +
      '<div class="toegevoegd__tekst"><span class="toegevoegd__naam">' + esc(String(it.product_title).split(' - TheWootz')[0]) + '</span>' + (sub ? '<span class="toegevoegd__sub">' + esc(sub) + '</span>' : '') + '</div>' +
      '<span class="toegevoegd__prijs">' + money(it.final_line_price || it.price * (it.quantity || 1)) + '</span>';
    var plek = $('[data-toegevoegd-aanbod]', vel);
    plek.innerHTML = '';
    vel.hidden = false;
    requestAnimationFrame(function(){ vel.classList.add('is-open'); });
    document.body.classList.add('toegevoegd-open');
    zetPil();
    laadSets().then(function(d){
      if (d && d.boardText) window.TheWootzBoardText = d.boardText;
      var c = cadeauStaat(cart, d);
      var a = kiesSetAanbod(cart, d, c);
      huidigAanbod = a;
      var x = kiesExtra(cart, d);
      // Eén aanbod tegelijk: het cadeau gaat voor, dan de set (of de plank met set), anders één product erbij.
      plek.innerHTML = c && c.aanbod ? velCadeauHtml(c) : (a ? velAanbodHtml(a) : (x ? velAanbodHtml(x) : ''));
    });
  }
  function kiesExtra(cart, d){
    if (!d || !d.extra) return null;
    if (plankMetSet(cart)) {
      var be = d.boardExtra;
      return be && !cart.items.some(function(i){ return String(i.product_id) === String(be.product); }) ? { soort: 'extra', x: be } : null;
    }
    // Ook wat al in een set in het mandje zit: geen losse olie aanbieden naast de complete set met olie.
    var inMandje = [];
    cart.items.forEach(function(i){
      inMandje.push(String(i.product_id));
      d.sets.forEach(function(set){
        if (String(set.v) === String(i.variant_id)) set.parts.forEach(function(pid){ inMandje.push(String(pid)); });
      });
    });
    for (var i = 0; i < d.extra.length; i++) { if (inMandje.indexOf(String(d.extra[i].product)) < 0) return { soort: 'extra', x: d.extra[i] }; }
    return null;
  }
  function velAanbodHtml(a){
    var beeld, titel, sub, knop;
    if (a.soort === 'extra') {
      return '<div class="toegevoegd__extra">' +
        (a.x.img ? '<img src="' + esc(a.x.img) + '" alt="" width="48" height="48">' : '') +
        '<div class="toegevoegd__tekst"><span class="toegevoegd__sub">' + esc(t('sheet_extra_title')) + '</span><span class="toegevoegd__naam">' + esc(a.x.t) + '</span></div>' +
        '<button type="button" class="toegevoegd__plus toegevoegd__plus--licht" data-quick-add="' + a.x.v + '">+ ' + money(a.x.p) + '</button>' +
      '</div>';
    }
    if (a.soort === 'plankset') {
      return '<div class="toegevoegd__aanbod">' +
        (a.winst > 0 ? '<span class="toegevoegd__vlag">' + esc(t('sheet_save', { bedrag: money(a.winst) })) + '</span>' : '') +
        (a.b.img ? '<img src="' + esc(a.b.img) + '" alt="" width="64" height="64">' : '') +
        '<div class="toegevoegd__tekst"><span class="toegevoegd__naam">' + esc(t('sheet_plank_title')) + '</span><span class="toegevoegd__sub">' + esc((window.TheWootzBoardText || '') + ' · ' + t('sheet_together', { set: money(a.b.setP) })) + '</span></div>' +
        '<button type="button" class="toegevoegd__plus" data-toegevoegd-knop>+ ' + money(a.extra) + '</button>' +
      '</div>';
    }
    if (a.soort === 'groter') {
      return '<div class="toegevoegd__aanbod">' +
        '<span class="toegevoegd__vlag">' + esc(t('groter_vlag')) + '</span>' +
        (a.set.img ? '<img src="' + esc(a.set.img) + '" alt="" width="64" height="64">' : '') +
        '<div class="toegevoegd__tekst"><span class="toegevoegd__naam">' + esc(t('groter_titel', { nieuw: a.set.m })) + '</span><span class="toegevoegd__sub">' + esc(t('groter_note', { nieuw: a.set.m, nu: a.van.m, kosten: setGegevens.fee })) + '</span></div>' +
        '<button type="button" class="toegevoegd__plus" data-toegevoegd-knop>+ ' + money(a.extra) + '</button>' +
      '</div>';
    }
    if (a.soort === 'compleet') {
      beeld = a.deel.img; titel = t('sheet_set_title');
      sub = t('sheet_set_sub', { naam: a.deel.t, los: money(a.set.p + a.winst), set: money(a.set.p) });
      knop = '+ ' + money(a.extra);
    } else if (a.soort === 'omzetten') {
      beeld = a.set.img; titel = t('sheet_swap_title'); sub = a.set.t; knop = t('set_swap_button');
    } else {
      beeld = a.offer.img; titel = a.offer.t;
      sub = t('sheet_offer_sub', { prijs: money(a.prijs), los: money(a.offer.p) });
      knop = '+ ' + money(a.prijs);
    }
    return '<div class="toegevoegd__aanbod">' +
      '<span class="toegevoegd__vlag">' + esc(t('sheet_save', { bedrag: money(a.winst) })) + '</span>' +
      (beeld ? '<img src="' + esc(beeld) + '" alt="" width="64" height="64">' : '') +
      '<div class="toegevoegd__tekst"><span class="toegevoegd__naam">' + esc(titel) + '</span><span class="toegevoegd__sub">' + esc(sub) + '</span></div>' +
      '<button type="button" class="toegevoegd__plus" data-toegevoegd-knop>' + esc(knop) + '</button>' +
    '</div>';
  }
  function sluitToegevoegd(){
    var vel = $('[data-toegevoegd]');
    if (!vel || vel.hidden) return;
    vel.classList.remove('is-open');
    document.body.classList.remove('toegevoegd-open');
    setTimeout(function(){ vel.hidden = true; zetPil(); }, 280);
  }
  // De hele kaart van het aanbod reageert, niet alleen de knop: klanten tikten op de kaart (Julian, 26-10-2026).
  // De klik gaat via de knop zelf, dus een knop die al bezig is (disabled) doet niets en er komt niets dubbel in.
  document.addEventListener('click', function(e){
    var kaart = e.target.closest('.toegevoegd__aanbod, .toegevoegd__extra');
    if (!kaart || e.target.closest('button, a')) return;
    var knop = kaart.querySelector('[data-toegevoegd-knop], [data-quick-add], [data-cadeau-knop]');
    if (knop && !knop.disabled) knop.click();
  });
  document.addEventListener('click', function(e){
    if (e.target.closest('[data-toegevoegd-sluit]')) { sluitToegevoegd(); return; }
    var k = e.target.closest('[data-toegevoegd-knop]');
    if (!k) return;
    var a = huidigAanbod;
    voerSetAanbodUit(k).then(function(cart){
      if (!cart || !a) return;
      var plek = $('[data-toegevoegd-aanbod]');
      plek.innerHTML = '<div class="toegevoegd__bespaard">' + esc(a.soort === 'korting' ? t('sheet_offer_done', { naam: a.offer.t }) : (a.soort === 'groter' ? t('groter_klaar') : t('sheet_saved', { bedrag: money(a.winst) }))) + '</div>';
      if (a.soort === 'plankset') {
        $('[data-toegevoegd-item]').innerHTML = (a.b.img ? '<img src="' + esc(a.b.img) + '" alt="" width="64" height="64">' : '') +
          '<div class="toegevoegd__tekst"><span class="toegevoegd__naam">' + esc(a.b.t) + '</span></div><span class="toegevoegd__prijs">' + money(a.b.setP) + '</span>';
      } else if (a.soort !== 'korting') {
        $('[data-toegevoegd-item]').innerHTML = (a.set.img ? '<img src="' + esc(a.set.img) + '" alt="" width="64" height="64">' : '') +
          '<div class="toegevoegd__tekst"><span class="toegevoegd__naam">' + esc(a.set.t) + '</span></div><span class="toegevoegd__prijs">' + money(a.set.p) + '</span>';
      }
    });
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') sluitToegevoegd(); });

  /* ---------- blogartikel: het product van het artikel als balk tijdens het lezen (snippet blog-product) ---------- */
  // Verschijnt zodra je een eind in de tekst zit, verdwijnt als de productkaart onder het artikel of de voettekst in
  // beeld komt. Na het kruisje blijft hij weg voor de rest van het bezoek.
  (function(){
    var balk = $('[data-blogbalk]');
    if (!balk) return;
    var tekst = $('.artikel'), kaart = $('[data-blogproduct]'), voet = $('.site-footer');
    var dicht = false, kaartInBeeld = false, voetInBeeld = false;
    try { dicht = sessionStorage.getItem('blogbalk-dicht') === '1'; } catch (e) {}
    function zet(){
      var start = tekst ? tekst.getBoundingClientRect().top + window.scrollY + 300 : 700;
      var toon = !dicht && window.scrollY + window.innerHeight > start && !kaartInBeeld && !voetInBeeld;
      if (toon !== balk.hidden) return;
      balk.hidden = !toon;
      document.body.classList.toggle('blogbalk-open', toon);
      zetPil();
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(items){
        items.forEach(function(it){ if (it.target === kaart) kaartInBeeld = it.isIntersecting; else voetInBeeld = it.isIntersecting; });
        zet();
      });
      if (kaart) io.observe(kaart);
      if (voet) io.observe(voet);
    }
    window.addEventListener('scroll', zet, { passive: true });
    balk.addEventListener('click', function(e){
      if (!e.target.closest('[data-blogbalk-sluit]')) return;
      dicht = true;
      try { sessionStorage.setItem('blogbalk-dicht', '1'); } catch (er) {}
      zet();
    });
    // Apart meten wat de blog oplevert: elke klik op In mandje in de balk of de kaart.
    document.addEventListener('click', function(e){
      if (e.target.closest('[data-blogbalk] [data-quick-add], [data-blogproduct] [data-quick-add]') && typeof window.clarity === 'function') window.clarity('event', 'blog_in_mandje');
    });
    zet();
  })();

  /* ---------- bol-sterren op kaarten: naar het product op bol.com, in een nieuw tabblad (snippet review-stars) ---------- */
  function openBol(e){
    var bl = e.target.closest('[data-bol-link]');
    if (!bl || (e.type === 'keydown' && e.key !== 'Enter')) return;
    e.preventDefault();
    e.stopPropagation();
    window.open(bl.getAttribute('data-bol-link'), '_blank', 'noopener');
  }
  document.addEventListener('click', openBol, true);
  document.addEventListener('keydown', openBol, true);

  /* ---------- vaste mandjeknop op de telefoon (zolang er iets in het mandje zit) ---------- */
  function zetPil(){
    var pil = $('[data-mandje-pil]');
    if (!pil) return;
    var n = parseInt(pil.getAttribute('data-aantal') || '0', 10);
    var b = document.body.classList;
    var bb = $('[data-bb-balk]:not([hidden])');
    var bbInBeeld = bb && bb.getBoundingClientRect().top < window.innerHeight && bb.getBoundingClientRect().bottom > 0;
    var anders = b.contains('drawer-open') || b.contains('qc-open') || b.contains('toegevoegd-open') || b.contains('koopbalk-open') || b.contains('blogbalk-open') || b.contains('menu-open') || !!$('[data-set-sticky].is-zichtbaar') || bbInBeeld;
    var toon = n > 0 && !anders;
    pil.classList.toggle('is-zichtbaar', toon);
    b.toggle('mandje-pil-open', toon);
  }
  window.addEventListener('scroll', function(){ zetPil(); }, { passive: true });
  zetPil();

  document.addEventListener('click', function(e){
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); fetchCart(); }
    if (e.target.closest('[data-cart-close]')) { closeCart(); }
    var chg = e.target.closest('[data-line-change]');
    if (chg) {
      fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ id: chg.getAttribute('data-line-change'), quantity: parseInt(chg.getAttribute('data-qty'),10) })
      }).then(function(r){ return r.json(); }).then(renderCart);
    }
    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      var label = quick.textContent;
      quick.textContent = t('added');
      quick.disabled = true;
      addToCart([{ id: quick.getAttribute('data-quick-add'), quantity: 1 }]).then(function(){
        setTimeout(function(){ quick.textContent = label; quick.disabled = false; }, 1200);
      }).catch(function(err){
        quick.textContent = t('failed_short');
        quick.title = err.message;
        setTimeout(function(){ quick.textContent = label; quick.disabled = false; quick.title = ''; }, 2200);
      });
    }
  });

  /* ---------- snelle betaalknoppen op de productpagina: na laden of bij eerste interactie ---------- */
  (function(){
    var el = $('[data-defer-express="page"]');
    if (!el) return;
    var done = false;
    function go(){ if (done) return; done = true; injectExpress(el); ['scroll','pointerdown','keydown','touchstart'].forEach(function(ev){ window.removeEventListener(ev, go); }); }
    ['scroll','pointerdown','keydown','touchstart'].forEach(function(ev){ window.addEventListener(ev, go, { once: true, passive: true }); });
    window.addEventListener('load', function(){ setTimeout(go, 3500); });
  })();

  /* Voor de losse onderdelen (plankkiezer, olie-rekenhulp, gravure): zelfde mandje en lade. */
  window.TheWootz = { addToCart: addToCart, openCart: openCart, money: money, esc: esc, t: t };

  /* ---------- productformulier met add-ons ---------- */
  var form = $('#product-form-main');
  if (form) {
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var items = [{ id: form.querySelector('[name="id"]').value, quantity: parseInt(form.querySelector('[name="quantity"]').value || '1', 10) }];
      var plan = form.querySelector('[name="selling_plan"]');
      if (plan && plan.value) items[0].selling_plan = parseInt(plan.value, 10);
      // Vaak samen gekocht: de losse onderdelen worden de set, voor de setprijs.
      if (window.TheWootzBundel) items = window.TheWootzBundel.items(items[0]);
      $$('.addon[aria-pressed="true"]', form).forEach(function(a){
        if (a.getAttribute('data-variant')) items.push({ id: a.getAttribute('data-variant'), quantity: 1 });
      });
      addToCart(items).catch(function(err){ window.alert(err.message); });
    });
  }
  document.addEventListener('click', function(e){
    var addon = e.target.closest('.addon');
    if (addon) { addon.setAttribute('aria-pressed', addon.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); }
    var q = e.target.closest('[data-qty-step]');
    if (q) {
      var input = q.parentElement.querySelector('input');
      var v = parseInt(input.value, 10) + parseInt(q.getAttribute('data-qty-step'), 10);
      input.value = Math.max(1, v);
    }
  });

  /* ---------- prijs in de koopknop: loopt mee met de prijs bovenaan (maat, abonnement) ---------- */
  (function(){
    var bron = $('[data-price]'), doel = $$('[data-atc-prijs]');
    if (!bron || !doel.length) return;
    var zet = function(){ doel.forEach(function(d){ d.textContent = bron.textContent; }); };
    new MutationObserver(zet).observe(bron, { childList: true, characterData: true, subtree: true });
  })();

  /* ---------- maatkiezer ---------- */
  (function(){
    var picker = $('[data-variant-picker]');
    if (!picker) return;
    var hidden = $('#product-form-main [name="id"]');
    var priceEl = $('[data-price]');
    var noteEl = $('[data-variant-note]');
    var sel = $('[data-variant-select]');

    function choose(id, price){
      if (hidden) hidden.value = id;
      if (priceEl && price) priceEl.textContent = price;
      var prijsNoot = $('[data-price-note]'), knop = $('[data-variant-id="' + id + '"]');
      if (prijsNoot && knop && knop.getAttribute('data-variant-noot')) prijsNoot.textContent = knop.getAttribute('data-variant-noot');
      $$('[data-variant-id]').forEach(function(b){ b.setAttribute('aria-pressed', b.getAttribute('data-variant-id') === String(id) ? 'true' : 'false'); });
      if (sel) sel.value = id;
      var sticky = $('.sticky-buy [data-quick-add]');
      if (sticky) sticky.setAttribute('data-quick-add', id);
      if (noteEl) {
        var btn = $$('[data-variant-id]').filter(function(b){ return b.getAttribute('data-variant-id') === String(id); })[0];
        var note = btn && btn.querySelector('.variant__note');
        noteEl.textContent = note ? note.textContent.trim() : '';
        noteEl.hidden = !note;
      }
      var url = new URL(window.location);
      url.searchParams.set('variant', id);
      window.history.replaceState({}, '', url);
      var pressed = $$('[data-variant-id]').filter(function(b){ return b.getAttribute('data-variant-id') === String(id); })[0];
      var vtitle = '';
      if (pressed && pressed.querySelector('.variant__size')) { vtitle = pressed.querySelector('.variant__size').textContent; }
      else if (sel && sel.options[sel.selectedIndex]) { vtitle = sel.options[sel.selectedIndex].textContent; }
      document.dispatchEvent(new CustomEvent('thewootz:variant', { detail: { id: String(id), title: vtitle.trim() } }));
    }

    picker.addEventListener('click', function(e){
      var b = e.target.closest('[data-variant-id]');
      if (b && !b.disabled) choose(b.getAttribute('data-variant-id'), b.getAttribute('data-variant-price'));
    });
    if (sel) sel.addEventListener('change', function(){
      var opt = sel.options[sel.selectedIndex];
      choose(sel.value, opt.getAttribute('data-variant-price'));
    });
  })();

  /* ---------- eenmalig of abonnement (productpagina, alleen bij producten met een abonnement) ---------- */
  (function(){
    var root = $('[data-purchase]');
    if (!root) return;
    var data;
    try { data = JSON.parse($('[data-po-data]', root).textContent); } catch (e) { return; }
    var idInput = $('#product-form-main [name="id"]');
    var input = $('[data-po-input]', root), sel = $('[data-po-plan]', root);
    var onceBtn = $('[data-po="once"]', root), subBtn = $('[data-po="sub"]', root);
    var priceEl = $('[data-price]'), priceNote = $('[data-price-note]'), policy = $('[data-po-policy]', root);
    var mode = 'once';

    function render(){
      var v = data[idInput ? idInput.value : ''] || { price: 0, plans: [] };
      var ps = v.plans || [];
      if (!ps.length) mode = 'once';
      subBtn.hidden = !ps.length;
      var keep = sel.value;
      sel.innerHTML = ps.map(function(p){ return '<option value="' + p.id + '">' + esc(p.label) + ' \u00B7 ' + money(p.price) + '</option>'; }).join('');
      if (ps.some(function(p){ return String(p.id) === keep; })) sel.value = keep;
      var plan = ps.filter(function(p){ return String(p.id) === sel.value; })[0] || ps[0];
      sel.hidden = !(mode === 'sub' && ps.length > 1);
      $('[data-po-once-price]', root).textContent = money(v.price);
      if (plan) {
        var save = plan.compare - plan.price, badge = $('[data-po-save]', root);
        $('[data-po-sub-price]', root).textContent = money(plan.price);
        $('[data-po-note]', root).textContent = t('sub_note', { plan: ps.length > 1 ? t('sub_you_choose') : plan.label });
        badge.textContent = save > 0 ? t('save_badge', { bedrag: Math.round(save / plan.compare * 100) + '%' }) : '';
        badge.hidden = !(save > 0);
      }
      onceBtn.setAttribute('aria-pressed', mode === 'once' ? 'true' : 'false');
      subBtn.setAttribute('aria-pressed', mode === 'sub' ? 'true' : 'false');
      input.value = (mode === 'sub' && plan) ? plan.id : '';
      if (priceEl) priceEl.textContent = money(mode === 'sub' && plan ? plan.price : v.price);
      // Eenmalig: de tekst van de uitvoering zelf ('Voor 5 stuks' bij een verpakking), anders 'Per stuk'.
      var vKnop = idInput ? $('[data-variant-id="' + idInput.value + '"]') : null;
      if (priceNote) priceNote.textContent = mode === 'sub' ? t('price_note_sub') : ((vKnop && vKnop.getAttribute('data-variant-noot')) || t('price_note_once'));
      if (policy) policy.hidden = mode !== 'sub';
      // Snelle betaalknoppen werken niet met abonnementen: verbergen zolang abonnement gekozen is.
      $$('#product-form-main .express-checkout').forEach(function(x){ x.hidden = mode === 'sub'; });
    }
    root.addEventListener('click', function(e){
      var b = e.target.closest('[data-po]');
      if (b) { mode = b.getAttribute('data-po'); render(); }
    });
    sel.addEventListener('change', render);
    document.addEventListener('thewootz:variant', render);
    render();
  })();

  /* ---------- footermenu's inklapbaar op de telefoon ---------- */
  // De kop krijgt een echte <button> erin; role="button" op de h3 zelf mag niet (een kop is geen knop).
  // Een button reageert vanzelf op Enter en spatie.
  (function(){
    var kolommen = $$('[data-footer-col]');
    if (!kolommen.length) return;
    var smal = window.matchMedia('(max-width:860px)');
    function zet(){
      kolommen.forEach(function(col){
        var kop = col.querySelector('h3');
        if (!kop) return;
        var knop = kop.querySelector('.footer__toggle');
        if (smal.matches){
          col.classList.add('is-collapsible');
          if (!knop){
            knop = document.createElement('button');
            knop.type = 'button';
            knop.className = 'footer__toggle';
            knop.setAttribute('aria-expanded', 'false');
            while (kop.firstChild) knop.appendChild(kop.firstChild);
            kop.appendChild(knop);
            knop.addEventListener('click', function(){
              var open = col.hasAttribute('open');
              if (open) { col.removeAttribute('open'); } else { col.setAttribute('open', ''); }
              knop.setAttribute('aria-expanded', open ? 'false' : 'true');
            });
          }
        } else {
          col.classList.remove('is-collapsible');
          col.removeAttribute('open');
          // breder scherm (bijvoorbeeld een gedraaide tablet): de kop is weer gewoon een kop
          if (knop){
            while (knop.firstChild) kop.insertBefore(knop.firstChild, knop);
            kop.removeChild(knop);
          }
        }
      });
    }
    zet();
    if (smal.addEventListener) smal.addEventListener('change', zet);
  })();

  /* ---------- kies een uitvoering in een klein venster en leg 'm meteen in het mandje ---------- */
  (function(){
    var box = $('[data-qc]');
    if (!box) return;
    var optionsEl = $('[data-qc-options]', box), priceEl = $('[data-qc-price]', box), errEl = $('[data-qc-error]', box);
    var chosen = null, lastFocus = null;

    function pick(btn){
      chosen = btn;
      $$('[data-qc-variant]', box).forEach(function(b){ b.setAttribute('aria-checked', b === btn ? 'true' : 'false'); });
      priceEl.textContent = btn.getAttribute('data-price');
      $('[data-qc-add]', box).disabled = false;
    }

    function open(link){
      var variants;
      try { variants = JSON.parse(link.getAttribute('data-variants') || '[]'); } catch (e) { return false; }
      if (!variants.length) return false;
      lastFocus = link;
      $('[data-qc-title]', box).textContent = link.getAttribute('data-title') || '';
      var opt = link.getAttribute('data-option') || '';
      $('[data-qc-option]', box).textContent = opt && opt.toLowerCase() !== 'title' ? t('choose_option', { optie: opt.toLowerCase() }) : '';
      var img = $('[data-qc-image]', box), src = link.getAttribute('data-image');
      img.hidden = !src; if (src) { img.src = src; img.alt = link.getAttribute('data-title') || ''; }
      $('[data-qc-link]', box).href = link.getAttribute('href') || '#';
      errEl.hidden = true;
      optionsEl.innerHTML = variants.map(function(v){
        return '<button type="button" class="qc__option" role="radio" aria-checked="false" data-qc-variant="' + v.id + '" data-price="' + esc(v.price) + '"' + (v.available ? '' : ' disabled') +
          '><span>' + esc(v.title) + (v.save ? '<small class="qc__save">' + esc(v.save) + '</small>' : '') + '</span><span class="qc__price">' + esc(v.price) + (v.available ? '' : ' &middot; uitverkocht') + '</span></button>';
      }).join('');
      var first = $('[data-qc-variant]:not([disabled])', box);
      chosen = null;
      $('[data-qc-add]', box).disabled = true;
      if (first) pick(first);
      box.hidden = false;
      // Eigen klasse: 'drawer-open' schuift ook het mandje open, dat lag dan over dit venster heen.
      document.body.classList.add('qc-open');
      if (first) first.focus();
      return true;
    }

    function close(){
      box.hidden = true;
      document.body.classList.remove('qc-open');
      if (lastFocus) lastFocus.focus();
    }

    document.addEventListener('click', function(e){
      var link = e.target.closest('[data-quick-choose]');
      if (link) { if (open(link)) e.preventDefault(); return; }
      if (e.target.closest('[data-qc-close]')) { close(); return; }
      var opt = e.target.closest('[data-qc-variant]');
      if (opt && !opt.disabled) { pick(opt); return; }
      var add = e.target.closest('[data-qc-add]');
      if (add && chosen) {
        var label = add.innerHTML;
        add.disabled = true; add.textContent = 'Even geduld';
        addToCart([{ id: parseInt(chosen.getAttribute('data-qc-variant'), 10), quantity: 1 }]).then(function(){
          add.innerHTML = label; add.disabled = false; close();
        }).catch(function(err){
          add.innerHTML = label; add.disabled = false;
          errEl.textContent = err.message || t('add_failed_retry'); errEl.hidden = false;
        });
      }
    });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !box.hidden) close(); });
  })();

  /* ---------- wat zit er bij de gekozen uitvoering ---------- */
  (function(){
    var note = $('[data-set-note]');
    if (!note) return;
    var kw = (note.getAttribute('data-keyword') || '').toLowerCase();
    document.addEventListener('thewootz:variant', function(e){
      var t = ((e.detail && e.detail.title) || '').toLowerCase();
      note.hidden = !(kw && t.indexOf(kw) > -1);
      // Met de set erbij geen tweede set aanbieden: het gewone blok gaat weg, dat met data-extras-set komt ervoor.
      $$('.product-extras:not(.bundel)').forEach(function(x){
        x.hidden = x.hasAttribute('data-extras-set') ? note.hidden : !note.hidden;
        if (x.hidden) $$('.addon[aria-pressed="true"]', x).forEach(function(a){ a.setAttribute('aria-pressed', 'false'); });
      });
    });
  })();

  /* ---------- galerij + lightbox ---------- */
  var main = $('[data-gallery-main]');
  if (main) {
    var srcs = $$('[data-gallery-thumb]').map(function(t){ return t.getAttribute('data-full'); });
    var idx = 0;
    function show(i){
      idx = (i + srcs.length) % srcs.length;
      main.removeAttribute('srcset');
      main.src = srcs[idx];
      var lb = $('[data-lightbox-img]'); if (lb) lb.src = srcs[idx];
      $$('[data-gallery-thumb]').forEach(function(t, n){ t.setAttribute('aria-current', n === idx ? 'true' : 'false'); });
      $$('[data-dot]').forEach(function(d, n){ if (n === idx) { d.setAttribute('data-active','true'); } else { d.removeAttribute('data-active'); } });
      var c = $('[data-lightbox-count]'); if (c) c.textContent = t('photo_of', { n: idx + 1, totaal: srcs.length });
    }
    var swipe = $('[data-gallery-swipe]');
    if (swipe) {
      var tick;
      swipe.addEventListener('scroll', function(){
        clearTimeout(tick);
        tick = setTimeout(function(){
          // stap = afstand tussen twee foto's (op de productpagina zijn ze smaller dan het scherm)
          var f = swipe.children, stap = f.length > 1 ? f[1].offsetLeft - f[0].offsetLeft : swipe.clientWidth;
          var i = Math.round(swipe.scrollLeft / (stap || swipe.clientWidth));
          if (i !== idx) show(i);
        }, 60);
      }, { passive: true });
    }
    document.addEventListener('click', function(e){
      var sw = e.target.closest('[data-swipe-index]');
      if (sw) { show(parseInt(sw.getAttribute('data-swipe-index'), 10)); $('.lightbox').classList.add('is-open'); document.body.style.overflow='hidden'; return; }
      var t = e.target.closest('[data-gallery-thumb]');
      if (t) show($$('[data-gallery-thumb]').indexOf(t));
      if (e.target.closest('[data-lightbox-open]')) { $('.lightbox').classList.add('is-open'); show(idx); document.body.style.overflow='hidden'; }
      if (e.target.closest('[data-lightbox-close]')) { $('.lightbox').classList.remove('is-open'); document.body.style.overflow=''; }
      if (e.target.closest('[data-lightbox-prev]')) show(idx - 1);
      if (e.target.closest('[data-lightbox-next]')) show(idx + 1);
    });
    document.addEventListener('keydown', function(e){
      if (!$('.lightbox') || !$('.lightbox').classList.contains('is-open')) return;
      if (e.key === 'Escape') { $('.lightbox').classList.remove('is-open'); document.body.style.overflow=''; }
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });
  }

  /* ---------- bezorgbelofte ---------- */
  function zetBezorgbelofte(el){
    var cutoff = parseInt(el.getAttribute('data-cutoff') || '15', 10);
    var D = t('days').split(',');
    var M = t('months').split(',');
    // Nederlandse tijd, ook als het apparaat van de bezoeker anders staat.
    var now;
    try { now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' })); } catch (e) { now = new Date(); }
    var work = function(d){ return d.getDay() >= 1 && d.getDay() <= 5; };
    var before = work(now) && now.getHours() < cutoff;
    var ship = new Date(now);
    if (!before) { do { ship.setDate(ship.getDate() + 1); } while (!work(ship)); }
    // Bezorging: het aantal werkdagen hoort bij het land van de bezoeker (zie snippets/shipping-promise).
    var minDagen = Math.max(1, parseInt(el.getAttribute('data-min-days') || '1', 10) || 1);
    var maxDagen = Math.max(minDagen, parseInt(el.getAttribute('data-max-days') || '2', 10) || minDagen);
    var werkdagenLater = function(vanaf, n){
      var d2 = new Date(vanaf);
      for (var i = 0; i < n; i++) { do { d2.setDate(d2.getDate() + 1); } while (!work(d2)); }
      return d2;
    };
    var del = werkdagenLater(ship, minDagen);
    var del2 = werkdagenLater(ship, maxDagen);
    var tom = new Date(now); tom.setDate(tom.getDate() + 1);
    var left = '';
    if (before) {
      var cut = new Date(now); cut.setHours(cutoff, 0, 0, 0);
      var mins = Math.max(1, Math.round((cut - now) / 60000));
      var h = Math.floor(mins / 60), m = mins % 60;
      left = h > 0 ? t('hours_minutes', { u: h, m: m }) : t('minutes', { m: m });
    }
    var shipDay = ship.toDateString() === tom.toDateString() ? t('tomorrow') : D[ship.getDay()] + ' ' + ship.getDate() + ' ' + M[ship.getMonth()];
    var titleEl = el.querySelector('[data-ship-title]'), s = el.querySelector('[data-ship-sub]');
    if (titleEl) titleEl.textContent = before ? t('ship_today', { tijd: left }) : t('ship_on', { dag: shipDay });
    var sameMonth = del.getMonth() === del2.getMonth();
    var vol = function(d2){ return D[d2.getDay()] + ' ' + d2.getDate() + ' ' + M[d2.getMonth()]; };
    var range = del.toDateString() === del2.toDateString()
      ? vol(del)
      : t('date_or', { a: D[del.getDay()] + ' ' + del.getDate() + (sameMonth ? '' : ' ' + M[del.getMonth()]), b: vol(del2) });
    var line = el.getAttribute('data-shipping-line') || '';
    var land = el.getAttribute('data-land') || '';
    if (s) s.textContent = (land ? t('delivery_expected_to', { bereik: range, land: land }) : t('delivery_expected', { bereik: range })) + line;
  }
  $$('[data-ship-promise]').forEach(zetBezorgbelofte);

  /* ---------- plankkiezer ---------- */
  $$('[data-chooser]').forEach(function(root){
    root.addEventListener('click', function(e){
      var b = e.target.closest('[data-rec]');
      if (!b) return;
      var active = b.getAttribute('aria-pressed') === 'true';
      $$('[data-rec]', root).forEach(function(x){ x.setAttribute('aria-pressed','false'); });
      var rec = active ? '' : b.getAttribute('data-rec');
      b.setAttribute('aria-pressed', active ? 'false' : 'true');
      $$('[data-col]', root).forEach(function(c){ c.classList.toggle('is-rec', !!rec && c.getAttribute('data-col') === rec); });
      var box = $('[data-rec-out]', root);
      if (box) {
        box.hidden = !rec;
        if (rec) {
          box.querySelector('[data-rec-text]').textContent = b.getAttribute('data-rec-text');
          var link = box.querySelector('a');
          link.href = b.getAttribute('data-rec-url');
          link.textContent = b.getAttribute('data-rec-cta');
        }
      }
    });
  });

  /* ---------- zoeken met suggesties ---------- */
  (function(){
    var panel = $('[data-search-panel]');
    if (!panel) return;
    var input = $('[data-search-input]', panel);
    var live = $('[data-search-live]', panel);
    var popular = $('[data-search-popular]', panel);
    var overlay = $('.search-overlay');
    var openers = $$('[data-search-open]');
    var suggestUrl = (panel.getAttribute('data-suggest-url') || '/search/suggest') + '.json';
    var searchUrl = panel.querySelector('form').getAttribute('action');
    var timer, controller;

    function open(){
      panel.hidden = false; if (overlay) overlay.hidden = false;
      openers.forEach(function(b){ b.setAttribute('aria-expanded', 'true'); });
      setTimeout(function(){ input.focus(); }, 30);
    }
    function close(){
      panel.hidden = true; if (overlay) overlay.hidden = true;
      openers.forEach(function(b){ b.setAttribute('aria-expanded', 'false'); });
    }
    function sized(url, w){ return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
    function price(p){
      var min = Math.round(parseFloat(p.price_min || p.price) * 100), max = Math.round(parseFloat(p.price_max || p.price) * 100);
      return (max > min ? t('from') + ' ' : '') + money(min);
    }
    function kind(url){ return url.indexOf('/collections/') > -1 ? t('kind_collection') : (url.indexOf('/blogs/') > -1 ? t('kind_article') : t('kind_page')); }
    function showPopular(on){ if (popular) popular.hidden = !on; }

    function render(q, data){
      var r = (data && data.resources && data.resources.results) || {};
      var products = r.products || [], others = [].concat(r.collections || [], r.pages || [], r.articles || []);
      if (!products.length && !others.length) {
        live.innerHTML = '<p class="sr-empty">Niets gevonden voor “' + esc(q) + '”. Probeer een ander woord, of kies een van deze:</p>';
        showPopular(true); input.setAttribute('aria-expanded', 'false');
        return;
      }
      showPopular(false);
      var html = '';
      if (products.length) {
        html += '<div><span class="search-panel__label">Producten</span><div class="sr-products">' + products.map(function(p){
          return '<a class="sr-product" href="' + esc(p.url) + '">' +
            (p.image ? '<img src="' + esc(sized(p.image, 112)) + '" alt="" width="56" height="56">' : '<span class="sr-product__ph"></span>') +
            '<span><span class="sr-product__title">' + esc(String(p.title).split(' - TheWootz')[0]) + '</span>' +
            (p.available === false ? '<span class="sr-product__soon">Binnenkort weer op voorraad</span>' : '') + '</span>' +
            '<span class="sr-product__price">' + price(p) + '</span></a>';
        }).join('') + '</div></div>';
      }
      if (others.length) {
        html += '<div><span class="search-panel__label">Pagina’s en artikelen</span><div class="sr-links">' + others.map(function(o){
          return '<a href="' + esc(o.url) + '">' + esc(o.title) + '<small>' + kind(o.url) + '</small></a>';
        }).join('') + '</div></div>';
      }
      html += '<a class="link-arrow sr-all" href="' + esc(searchUrl + '?q=' + encodeURIComponent(q)) + '">Alle resultaten voor “' + esc(q) + '” &rarr;</a>';
      live.innerHTML = html;
      input.setAttribute('aria-expanded', 'true');
    }

    function suggest(q){
      if (controller) controller.abort();
      controller = window.AbortController ? new AbortController() : null;
      var url = suggestUrl + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function(r){ return r.json(); })
        .then(function(d){ if (input.value.trim() === q) render(q, d); })
        .catch(function(){});
    }

    input.addEventListener('input', function(){
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { live.innerHTML = ''; showPopular(true); input.setAttribute('aria-expanded', 'false'); return; }
      timer = setTimeout(function(){ suggest(q); }, 180);
    });

    document.addEventListener('click', function(e){
      if (e.target.closest('[data-search-open]')) { e.preventDefault(); if (panel.hidden) { open(); } else { close(); } return; }
      if (e.target.closest('[data-search-close]')) { close(); return; }
      var term = e.target.closest('[data-search-term]');
      if (term) { e.preventDefault(); input.value = term.getAttribute('data-search-term'); input.dispatchEvent(new Event('input')); input.focus(); }
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && !panel.hidden) { close(); return; }
      var typing = /INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName) || document.activeElement.isContentEditable;
      if (e.key === '/' && !typing && panel.hidden) { e.preventDefault(); open(); }
    });
  })();

  /* ---------- vaste filterbalk op collectiepagina's: hoogte van de kop en schaduw zodra hij vastzit ---------- */
  function kopHoogte(){ var k = document.querySelector('.site-header'); return k ? k.getBoundingClientRect().height : 0; }
  (function(){
    var balk = document.querySelector('[data-bs-vast]');
    if (!balk) return;
    function zet(){ document.documentElement.style.setProperty('--kop-h', Math.round(kopHoogte()) + 'px'); }
    function schaduw(){ balk.classList.toggle('is-vast', balk.getBoundingClientRect().top <= kopHoogte() + 1 && window.pageYOffset > 0); }
    zet(); schaduw();
    window.addEventListener('resize', zet);
    window.addEventListener('scroll', schaduw, { passive: true });
  })();

  /* ---------- bestsellers: filterknoppen en het vinkje voor de plank met onderhoudsset ---------- */
  document.addEventListener('click', function(e){
    var f = e.target.closest('[data-bs-filter]');
    if (f) {
      var root = f.closest('[data-bs]'), groep = f.getAttribute('data-bs-filter');
      $$('[data-bs-filter]', root).forEach(function(b){ b.setAttribute('aria-pressed', b === f ? 'true' : 'false'); });
      $$('[data-bs-groep]', root).forEach(function(k){ k.hidden = !!groep && k.getAttribute('data-bs-groep') !== groep; });
      // Vaste filterbalk: ben je al voorbij het begin van de producten, dan terug naar de eerste kaart.
      if (f.closest('[data-bs-vast]') && root.getBoundingClientRect().top < 0) {
        window.scrollTo({ top: root.getBoundingClientRect().top + window.pageYOffset - kopHoogte(), behavior: 'smooth' });
      }
      return;
    }
    // Het vinkje wisselt tussen de twee verborgen uitvoeringen; shop-tabs.js werkt prijs en besparing bij.
    var vink = e.target.closest('[data-bs-set]');
    if (vink) {
      var aan = vink.getAttribute('aria-checked') !== 'true';
      vink.setAttribute('aria-checked', aan ? 'true' : 'false');
      var opties = $$('[data-st-variant]', vink.closest('[data-st-card]'));
      var doel = opties[aan ? 1 : 0];
      if (doel) doel.click();
    }
  });

  /* ---------- stel zelf samen: eigen bundel met korting per aantal (sections/bundel-bouwer) ---------- */
  $$('[data-bb]').forEach(function(root){
    var treden = [];
    [1, 2].forEach(function(i){
      var n = parseInt(root.getAttribute('data-n' + i), 10), pct = parseInt(root.getAttribute('data-p' + i), 10);
      if (n && pct) treden.push({ n: n, pct: pct });
    });
    treden.sort(function(a, b){ return a.n - b.n; });
    var balk = $('[data-bb-balk]', root);
    var gekozen = function(){ return $$('[data-bb-kies][aria-pressed="true"]', root); };
    function bij(){
      var g = gekozen(), n = g.length;
      var som = g.reduce(function(a, b){ return a + parseInt(b.getAttribute('data-price'), 10); }, 0);
      var pct = 0, volgende = null;
      treden.forEach(function(tr){ if (n >= tr.n) pct = tr.pct; else if (!volgende) volgende = tr; });
      // Zoals Shopify: per product de korting naar beneden afgerond.
      var korting_c = g.reduce(function(a, b){ return a + Math.floor(parseInt(b.getAttribute('data-price'), 10) * pct / 100); }, 0);
      balk.hidden = n === 0;
      $('[data-bb-aantal]', balk).textContent = n === 1 ? t('bb_count_one') : t('bb_count', { n: n });
      var korting = $('[data-bb-korting]', balk);
      korting.hidden = !pct; korting.textContent = pct ? t('bb_discount', { pct: pct }) : '';
      $('[data-bb-hint]', balk).textContent = volgende ? t('bb_next', { n: volgende.n - n, pct: volgende.pct }) : t('bb_max');
      var was = $('[data-bb-was]', balk);
      was.hidden = !pct; was.textContent = pct ? money(som) : '';
      $('[data-bb-totaal]', balk).textContent = money(som - korting_c);
    }
    root.addEventListener('click', function(e){
      var k = e.target.closest('[data-bb-kies]');
      if (k && !k.disabled) {
        var aan = k.getAttribute('aria-pressed') !== 'true';
        k.setAttribute('aria-pressed', aan ? 'true' : 'false');
        $('[data-bb-kies-tekst]', k).textContent = aan ? t('bb_chosen') : t('bb_choose');
        k.closest('.bb-kaart').classList.toggle('is-gekozen', aan);
        bij();
        return;
      }
      var knop = e.target.closest('[data-bb-add]');
      if (!knop) return;
      var items = gekozen().map(function(b){ return { id: parseInt(b.getAttribute('data-variant'), 10), quantity: 1 }; });
      if (!items.length) return;
      var fout = $('[data-bb-fout]', balk), label = knop.textContent;
      knop.disabled = true; knop.textContent = t('please_wait'); fout.hidden = true;
      addToCart(items).then(function(){
        gekozen().forEach(function(b){ b.setAttribute('aria-pressed', 'false'); $('[data-bb-kies-tekst]', b).textContent = t('bb_choose'); b.closest('.bb-kaart').classList.remove('is-gekozen'); });
        knop.disabled = false; knop.textContent = label; bij();
      }).catch(function(err){
        knop.disabled = false; knop.textContent = label;
        fout.textContent = err.message; fout.hidden = false;
      });
    });
  });

  /* ---------- sets op de onderhoudspagina: de carrousel op de telefoon opent op de uitgelichte set ---------- */
  $$('.sz-sets').forEach(function(rij){
    var uit = $('.sz-set--uitgelicht', rij);
    if (!uit || rij.scrollWidth <= rij.clientWidth) return;
    rij.scrollLeft = uit.offsetLeft - (rij.clientWidth - uit.clientWidth) / 2;
  });

  /* ---------- zwevend setkaartje (bundel-promo als 'zwevend kaartje') ---------- */
  (function(){
    var el = $('[data-set-sticky]');
    if (!el) return;
    var dicht = false;
    try { dicht = sessionStorage.getItem('set-sticky-dicht') === '1'; } catch (e) {}
    if (dicht) { el.remove(); return; }
    var toon = function(){ el.classList.toggle('is-zichtbaar', window.scrollY > 700 && !document.body.classList.contains('drawer-open')); };
    window.addEventListener('scroll', toon, { passive: true });
    toon();
    el.addEventListener('click', function(e){
      if (!e.target.closest('[data-set-sticky-sluit]')) return;
      try { sessionStorage.setItem('set-sticky-dicht', '1'); } catch (err) {}
      el.classList.remove('is-zichtbaar');
      setTimeout(function(){ el.remove(); }, 300);
    });
  })();

  /* ---------- deadline met aftelling ---------- */
  $$('[data-deadline]').forEach(function(el){
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(el.getAttribute('data-deadline') || '');
    if (!m) return;
    var end = new Date(+m[1], +m[2] - 1, +m[3], 23, 59, 59);
    var days = Math.ceil((end - new Date()) / 86400000);
    var count = el.querySelector('[data-deadline-count]');
    if (days < 1 || end < new Date()) {
      var after = el.getAttribute('data-deadline-after');
      if (after) { el.querySelector('[data-deadline-text]').textContent = after; } else { el.hidden = true; }
      return;
    }
    if (count) {
      count.textContent = days === 1 ? t('deadline_last_day') : t('deadline_days', { n: days });
      count.hidden = false;
    }
  });

  /* ---------- koopbalk op de productpagina: zodra de koopknop niet in beeld is ----------
     De knop verstuurt het gewone formulier (maat, abonnement, add-ons, set gaan mee); prijs, variant
     en foto lopen mee met de keuze. */
  (function(){
    var bar = $('[data-sticky-buy]'), form = $('#product-form-main');
    if (!bar || !form || !('IntersectionObserver' in window)) return;
    var koop = form.querySelector('.product-buy') || form;
    new IntersectionObserver(function(entries){
      var e = entries[0];
      // Zichtbaar zodra de koopknop niet in beeld is: erboven of nog eronder (laptop, telefoon).
      var zichtbaar = !e.isIntersecting;
      bar.classList.toggle('is-visible', zichtbaar);
      // De kortingsknop van Klaviyo staat ook linksonder; die schuift dan mee omhoog (theme.css).
      document.body.classList.toggle('koopbalk-open', zichtbaar);
    }, { rootMargin: '0px 0px -60px 0px' }).observe(koop);
    var varianten = {};
    try { varianten = JSON.parse($('[data-sticky-variants]', bar).textContent); } catch (err) {}
    var prijsBron = $('[data-price]'), prijs = $('[data-sticky-price]', bar), naam = $('[data-sticky-variant]', bar), beeld = $('[data-sticky-img]', bar);
    var id = form.querySelector('[name="id"]');
    function bij(){
      if (prijsBron && prijs) prijs.textContent = prijsBron.textContent;
      var v = id && varianten[id.value];
      if (!v) return;
      if (naam) naam.textContent = v.t;
      if (beeld && v.img && beeld.getAttribute('src') !== v.img) beeld.src = v.img;
    }
    if (prijsBron) new MutationObserver(bij).observe(prijsBron, { childList: true, characterData: true, subtree: true });
    form.addEventListener('change', bij);
    document.addEventListener('click', function(){ setTimeout(bij, 0); });
    var knop = $('[data-sticky-add]', bar);
    if (knop) knop.addEventListener('click', function(){
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  })();

  /* ---------- vaste knop op mobiel (zakelijk) ---------- */
  (function(){
    var bar = $('[data-sticky-cta]');
    var hero = $('[data-b2b-hero]');
    if (!bar || !hero || !('IntersectionObserver' in window)) return;
    var form = $('#offerte');
    var heroVisible = true, formVisible = false;
    bar.hidden = false;
    function update(){ bar.classList.toggle('is-visible', !heroVisible && !formVisible); }
    new IntersectionObserver(function(entries){ entries.forEach(function(e){
      if (e.target === hero) heroVisible = e.isIntersecting; else formVisible = e.isIntersecting;
    }); update(); }, { rootMargin: '0px 0px -40% 0px' }).observe(hero);
    if (form) new IntersectionObserver(function(entries){ formVisible = entries[0].isIntersecting; update(); }).observe(form);
  })();

  /* ---------- onderhoudskiezer ---------- */
  $$('[data-mpicker]').forEach(function(root){
    root.addEventListener('click', function(e){
      var tab = e.target.closest('[data-mp-option]');
      if (!tab) return;
      e.preventDefault();
      var key = tab.getAttribute('data-mp-option');
      $$('[data-mp-option]', root).forEach(function(t){ t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
      $$('[data-mp-panel]', root).forEach(function(p){ p.hidden = p.getAttribute('data-mp-panel') !== key; });
      var panel = $('[data-mp-panel="' + key + '"]', root);
      if (panel && panel.getBoundingClientRect().top > window.innerHeight * 0.75) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ---------- zakelijke routes ---------- */
  $$('[data-tracks]').forEach(function(root){
    root.addEventListener('click', function(e){
      var b = e.target.closest('[data-track]');
      if (!b) return;
      var key = b.getAttribute('data-track');
      $$('[data-track]', root).forEach(function(x){
        var on = x === b;
        x.setAttribute('aria-pressed', on ? 'true' : 'false');
        var cta = x.querySelector('.track-card__cta');
        if (cta) cta.textContent = on ? t('track_current') : t('track_view');
      });
      $$('[data-track-panel]').forEach(function(p){ p.hidden = p.getAttribute('data-track-panel') !== key; });
    });
  });

  /* ---------- beweging bij scrollen ---------- */
  (function(){
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var header = $('.site-header');
    if (header) {
      var onScroll = function(){ header.classList.toggle('is-scrolled', window.scrollY > 8); };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
    if (reduce || !('IntersectionObserver' in window)) return;

    // Wat bij het laden al in beeld is, blijft staan; alleen inhoud verderop komt in beeld geschoven.
    var selector = [
      'main .section .wrap > .stack', 'main .section .grid > *', 'main .steps > li', 'main .mp-options > *',
      'main .faq > details', 'main .trust__item', 'main .compare', 'main .usp-grid', 'main .newsletter__inner > *',
      'main .section .wrap > .row', 'main .section .wrap > div > .btn', 'main .spec', 'main .b2b-hero__media'
    ].join(',');
    var fold = window.innerHeight * 0.92;
    var marked = [];
    $$(selector).forEach(function(el){
      if (el.closest('.reveal') || el.closest('[hidden]') || el.getBoundingClientRect().top < fold) return;
      var i = 0, s = el.previousElementSibling;
      while (s && i < 6) { if (s.classList.contains('reveal')) i++; s = s.previousElementSibling; }
      el.style.setProperty('--reveal-delay', (i * 80) + 'ms');
      el.classList.add('reveal');
      marked.push(el);
    });
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    marked.forEach(function(el){ io.observe(el); });

    // Cijfers tellen op: '100+', '4+', '1.500+', 'Vanaf 10', '100% NL', '14 dagen'
    var counters = $$('.stat-value, .fact__num');
    var cio = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting) return;
        cio.unobserve(e.target);
        // Ook getallen met een duizendtalteken ('1.500+', '1,500+'): tijdens het tellen blijft dat teken staan.
        var el = e.target, text = el.textContent, m = /(\d{1,3}(?:[.,]\d{3})+|\d+)/.exec(text);
        if (!m) return;
        var sep = (/[.,]/.exec(m[1]) || [''])[0];
        var fmt = function (n) { return sep ? String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep) : String(n); };
        var target = parseInt(m[1].replace(/[.,]/g, ''), 10), start = null, dur = Math.min(1600, 600 + target * 6);
        if (target < 2) return;
        var before = text.slice(0, m.index), after = text.slice(m.index + m[1].length);
        el.style.minWidth = el.offsetWidth + 'px';
        function step(ts){
          if (!start) start = ts;
          var p = Math.min(1, (ts - start) / dur), eased = 1 - Math.pow(1 - p, 3);
          el.textContent = before + fmt(Math.round(target * eased)) + after;
          if (p < 1) requestAnimationFrame(step); else el.textContent = text;
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    counters.forEach(function(el){ if (el.getBoundingClientRect().top > fold) cio.observe(el); });
  })();

  /* ---------- productkaart: tweede foto laden bij eerste hover ---------- */
  if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', function(e){
      var media = e.target.closest && e.target.closest('.pcard') && e.target.closest('.pcard').querySelector('.pcard__media[data-img2]');
      if (!media) return;
      var img = document.createElement('img');
      img.className = 'pcard__img2'; img.alt = ''; img.setAttribute('aria-hidden', 'true'); img.width = 800; img.height = 800;
      img.src = media.getAttribute('data-img2');
      media.removeAttribute('data-img2');
      var first = media.querySelector('img');
      media.insertBefore(img, first ? first.nextSibling : media.firstChild);
    });
  }

  /* ---------- aankondigingsbalk op mobiel wisselt ---------- */
  $$('.announce [data-rotate]').forEach(function(el){
    var items = el.getAttribute('data-rotate').split(/\s*[·|]\s*/).filter(Boolean);
    if (items.length < 2 || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    var i = 0;
    setInterval(function(){
      el.classList.add('is-out');
      setTimeout(function(){ i = (i + 1) % items.length; el.textContent = items[i]; el.classList.remove('is-out'); }, 350);
    }, 3800);
  });

  /* ---------- vraag naar het land ----------
     Geen automatische doorverwijzing (daar stuurt Google ook zijn crawler mee het verkeerde land in),
     maar een vraag in de aankondigingsbalk die je kunt wegklikken. Shopify geeft het vermoedelijke land
     terug op basis van het IP-adres. Tussen landen met dezelfde prijzen en verzending vragen we niets,
     maar zetten we het land stil om: de advertenties van Google sturen ook Nederlanders binnen met
     ?country=BE, en dan stond afrekenen op België (Julian 29-10-2026). */
  (function(){
    var box = $('[data-geo]');
    if (!box || !window.fetch) return;
    var landen;
    try { landen = JSON.parse($('[data-geo-data]', box).textContent); } catch (e) { return; }
    var KEY = 'tw-geo', BEDENKTIJD = 30 * 24 * 60 * 60 * 1000, weggeklikt = false;
    try {
      var eerder = window.localStorage.getItem(KEY);
      weggeklikt = !!eerder && (Date.now() - parseInt(eerder, 10)) < BEDENKTIJD;
    } catch (e) {}

    var nuLand = (box.getAttribute('data-country') || '').toUpperCase();
    var zelfde = (box.getAttribute('data-same') || '').split(',').filter(Boolean);
    var balk = box.closest('.announce');
    if (weggeklikt && zelfde.indexOf(nuLand) < 0) return;

    function vermoedLand(){
      return fetch('/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true&currency[enabled]=true', { headers: { Accept: 'application/json' } })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(j){
          if (!j) return '';
          var d = j.detected_values || {};
          if (d.country && d.country.handle) return String(d.country.handle).toUpperCase();
          var s = (j.suggestions || []).filter(function(x){ return x.type === 'country' && x.handle; })[0];
          return s ? String(s.handle).toUpperCase() : '';
        })
        .catch(function(){ return ''; });
    }

    function onthoud(){ try { window.localStorage.setItem(KEY, String(Date.now())); } catch (e) {} }
    function meld(naam){ if (typeof window.clarity === 'function') window.clarity('event', naam); }

    /* Zelfde prijzen, dus de pagina hoeft niet te herladen. Het mandje blijft staan en afrekenen opent
       daarna in het juiste land. country en currency gaan uit het adres, anders zet herladen het terug. */
    function stilOmzetten(code){
      var f = $('form', box);
      if (!f) return;
      var fd = new FormData(f);
      fd.set('country_code', code);
      // De pagina herlaadt niet: zonder dit bleef een Nederlander 'Verwacht in huis in België' lezen.
      var doel = landen.filter(function(c){ return String(c.code).toUpperCase() === code; })[0];
      $$('[data-ship-promise]').forEach(function(el){
        el.setAttribute('data-land', code === 'NL' || !doel ? '' : doel.name);
        zetBezorgbelofte(el);
      });
      fetch(f.action, { method: 'POST', body: fd, redirect: 'manual', credentials: 'same-origin' })
        .then(function(){
          meld('land_omgezet');
          try {
            var u = new URL(window.location.href);
            if (u.searchParams.has('country') || u.searchParams.has('currency')) {
              u.searchParams.delete('country');
              u.searchParams.delete('currency');
              window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
            }
          } catch (e) {}
        })
        .catch(function(){});
    }

    vermoedLand().then(function(code){
      if (!code || code === nuLand) return;
      if (zelfde.indexOf(code) > -1 && zelfde.indexOf(nuLand) > -1) { stilOmzetten(code); return; }
      if (weggeklikt) return;
      var land = landen.filter(function(c){ return String(c.code).toUpperCase() === code; })[0];
      if (!land) return;

      $('[data-geo-text]', box).textContent = t('geo_country', { land: land.name });
      $('[data-geo-country]', box).value = land.code;
      box.hidden = false;
      if (balk) balk.classList.add('is-geo');
      meld('geo_vraag');
      $('[data-geo-accept]', box).addEventListener('click', function(){ onthoud(); meld('geo_ja'); });
      $('[data-geo-dismiss]', box).addEventListener('click', function(){
        onthoud();
        meld('geo_weg');
        box.hidden = true;
        if (balk) balk.classList.remove('is-geo');
      });
    });
  })();

  fetchCart();
})();

/* ---------- productinformatie: vragen na vijf inklappen ---------- */
(function(){
  var faq = document.querySelector('[data-faq-kort]'), meer = document.querySelector('[data-faq-meer]');
  if (faq && meer) {
    var max = parseInt(faq.getAttribute('data-faq-kort'), 10) || 5, rijen = faq.querySelectorAll(':scope > details');
    if (rijen.length > max) {
      faq.classList.add('is-kort');
      meer.textContent = meer.getAttribute('data-label').replace('{n}', rijen.length);
      meer.hidden = false;
      meer.addEventListener('click', function(){ faq.classList.remove('is-kort'); meer.hidden = true; });
    }
  }
})();

/* ---------- terug op voorraad: aanmelding rechtstreeks bij Klaviyo ---------- */
(function(){
  var bis = document.querySelector('[data-bis]'); if (!bis) return;
  var open = bis.querySelector('[data-bis-open]'), form = bis.querySelector('[data-bis-form]'),
      klaar = bis.querySelector('[data-bis-klaar]'), fout = bis.querySelector('[data-bis-fout]'), mail = bis.querySelector('[data-bis-email]');
  open.addEventListener('click', function(){ form.hidden = false; open.setAttribute('aria-expanded', 'true'); open.hidden = true; mail.focus(); });
  form.addEventListener('submit', function(e){
    e.preventDefault(); fout.hidden = true;
    // de uitvoering die de bezoeker heeft aangeklikt, anders de eerste
    var gekozen = document.querySelector('[data-variant-picker] [data-variant-id][aria-pressed="true"]');
    var variant = (gekozen && gekozen.getAttribute('data-variant-id')) || bis.getAttribute('data-variant');
    var knop = form.querySelector('[type=submit]'); knop.disabled = true;
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(bis.getAttribute('data-bedrijf')), {
      method: 'POST',
      headers: { 'content-type': 'application/vnd.api+json', 'revision': '2024-10-15' },
      body: JSON.stringify({ data: { type: 'back-in-stock-subscription',
        attributes: { profile: { data: { type: 'profile', attributes: { email: mail.value.trim() } } }, channels: ['EMAIL'] },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant } } } } })
    }).then(function(r){
      if (!r.ok) throw new Error(r.status);
      form.hidden = true; klaar.hidden = false;
    }).catch(function(){ fout.hidden = false; knop.disabled = false; });
  });
})();

/* ---------- vaak samen gekocht: losse onderdelen worden de bestaande set ---------- */
(function () {
  var el = document.querySelector('[data-bundel]'), form = document.getElementById('product-form-main');
  if (!el || !form) return;
  var data;
  try { data = JSON.parse(el.querySelector('[data-bundel-data]').textContent); } catch (e) { return; }
  var T = window.TheWootz || {};
  var geld = function (c) { return T.money ? T.money(c) : (c / 100).toFixed(2).replace('.', ','); };
  var basis = el.getAttribute('data-basis'), basisVar = el.getAttribute('data-basis-variant'), basisPrijs = parseInt(el.getAttribute('data-basis-prijs'), 10);
  var uitkomst = el.querySelector('[data-bundel-uitkomst]');
  var knoppen = Array.prototype.slice.call(el.querySelectorAll('[data-bundel-key]'));
  function item(a) { return { key: a.getAttribute('data-bundel-key'), id: a.getAttribute('data-bundel-variant'), prijs: parseInt(a.getAttribute('data-bundel-prijs'), 10) }; }
  function gekozen() { return knoppen.filter(function (a) { return a.getAttribute('aria-pressed') === 'true'; }).map(item); }
  // De set bestaat alleen als los stuk zonder abonnement; bij een voordeelverpakking of abonnement blijft alles los.
  function kanSet() {
    var plan = form.querySelector('[name="selling_plan"]');
    return form.querySelector('[name="id"]').value === basisVar && !(plan && plan.value);
  }
  // Voor een keuze: de voordeligste set die erin past, plus wat er los bij komt.
  function reken(sel) {
    var prijs = {}; prijs[basis] = basisPrijs;
    sel.forEach(function (x) { prijs[x.key] = x.prijs; });
    var beste = null;
    if (sel.length && kanSet()) {
      data.bundels.forEach(function (b) {
        if (b.keys.indexOf(basis) < 0) return;
        if (!b.keys.every(function (k) { return prijs[k] !== undefined; })) return;
        var los = b.keys.reduce(function (t, k) { return t + prijs[k]; }, 0), winst = los - b.price;
        if (winst > 0 && (!beste || winst > beste.winst)) beste = { b: b, winst: winst };
      });
    }
    var rest = sel.filter(function (x) { return !beste || beste.b.keys.indexOf(x.key) < 0; });
    var los = basisPrijs + sel.reduce(function (t, x) { return t + x.prijs; }, 0);
    var totaal = beste ? beste.b.price + rest.reduce(function (t, x) { return t + x.prijs; }, 0) : los;
    return { sel: sel, beste: beste, rest: rest, los: los, totaal: totaal };
  }
  function teken() {
    var sel = gekozen(), p = reken(sel), set = kanSet();
    // Per onderdeel: wat het aan het totaal toevoegt, en dus wat je bespaart door het erbij te nemen.
    knoppen.forEach(function (a) {
      var x = item(a), aan = a.getAttribute('aria-pressed') === 'true';
      var zonder = sel.filter(function (y) { return y.key !== x.key; });
      var erbij = reken(zonder.concat([x])).totaal - reken(zonder).totaal;
      var winst = set ? x.prijs - erbij : 0;
      var was = a.querySelector('[data-bundel-was]'), meer = a.querySelector('[data-bundel-meer]'), label = a.querySelector('[data-bundel-los]');
      if (aan) {
        // Gekozen: geen eigen rekensom per onderdeel, het totaal eronder zegt wat je bespaart.
        var inSet = p.beste && p.beste.b.keys.indexOf(x.key) > -1;
        was.textContent = geld(x.prijs); was.hidden = !inSet;
        meer.textContent = inSet ? '' : '+ ' + geld(x.prijs);
        label.textContent = inSet ? data.tekst.inset : data.tekst.erlos;
        label.classList.toggle('is-voordeel', !!inSet);
        return;
      }
      if (winst > 0) {
        was.textContent = geld(x.prijs); was.hidden = false;
        meer.textContent = (erbij >= 0 ? '+ ' + geld(erbij) : '− ' + geld(-erbij));
        label.textContent = data.tekst.bespaar.replace('[bedrag]', geld(winst));
        label.classList.add('is-voordeel');
      } else {
        was.hidden = true;
        meer.textContent = '+ ' + geld(x.prijs);
        label.textContent = data.tekst.losprijs.replace('[prijs]', geld(x.prijs));
        label.classList.remove('is-voordeel');
      }
    });
    if (!sel.length) { uitkomst.hidden = true; return; }
    uitkomst.hidden = false;
    var badge = uitkomst.querySelector('[data-bundel-badge]'), kop = uitkomst.querySelector('[data-bundel-kop]'), uitleg = uitkomst.querySelector('[data-bundel-uitleg]');
    var van = uitkomst.querySelector('[data-bundel-van]'), voor = uitkomst.querySelector('[data-bundel-voor]');
    uitkomst.classList.toggle('is-set', !!p.beste);
    if (p.beste) {
      var pct = Math.round(p.beste.winst / p.los * 100);
      badge.textContent = data.tekst.bespaar.replace('[bedrag]', geld(p.los - p.totaal)) + ' · ' + pct + '%'; badge.hidden = false;
      kop.textContent = data.tekst.set.replace('{naam}', p.beste.b.naam);
      uitleg.textContent = data.tekst.inmandje + (p.rest.length ? ' ' + data.tekst.plus : '');
      van.textContent = geld(p.los); van.hidden = false;
      voor.textContent = geld(p.totaal); voor.hidden = false;
    } else if (set) {
      badge.hidden = true; van.hidden = true;
      kop.textContent = data.tekst.los; uitleg.textContent = '';
      voor.textContent = geld(p.totaal); voor.hidden = false;
    } else {
      // Voordeelverpakking of abonnement: geen setprijs, en het totaal hangt van die keuze af.
      badge.hidden = true; van.hidden = true; voor.hidden = true;
      kop.textContent = data.tekst.los; uitleg.textContent = data.tekst.alleen1;
    }
  }
  window.TheWootzBundel = {
    items: function (eerste) {
      var sel = gekozen();
      if (!sel.length) return [eerste];
      var p = reken(sel), uit = [];
      if (p.beste) uit.push({ id: p.beste.b.id, quantity: eerste.quantity });
      else uit.push(eerste);
      p.rest.forEach(function (x) { uit.push({ id: x.id, quantity: 1 }); });
      return uit;
    }
  };
  // De knoppen wisselen via de algemene klikafhandeling; daarna pas rekenen.
  ['click', 'change'].forEach(function (ev) { form.addEventListener(ev, function () { setTimeout(teken, 0); }); });
  teken();
})();

/* ---------- set: het voordeelblok van de gekozen variant tonen ---------- */
(function () {
  var blokken = Array.prototype.slice.call(document.querySelectorAll('[data-setvoordeel]')), form = document.getElementById('product-form-main');
  if (blokken.length < 2 || !form) return;
  function zet() {
    var id = form.querySelector('[name="id"]').value;
    blokken.forEach(function (b) { b.hidden = b.getAttribute('data-setvoordeel') !== id; });
  }
  ['click', 'change'].forEach(function (ev) { form.addEventListener(ev, function () { setTimeout(zet, 0); }); });
})();

/* ---------- cookiemelding: op de telefoon de drie knoppen naast elkaar ---------- */
// De melding staat in een eigen schaduwlaag, daar komt theme.css niet in. Eigen CSS in Consentmo vraagt om het Plus-plan (Julian 2-11).
(function () {
  var css = '@media (max-width:600px){'
    + '.cc-window .csm-cmp-body{padding:14px 16px!important;gap:10px!important}'
    + '.cc-window .cc-compliance{flex-direction:row!important;flex-wrap:nowrap!important;width:100%!important;gap:6px!important}'
    + '.cc-window .cc-compliance .cc-btn{width:calc((100% - 12px)/3)!important;min-width:0!important;padding:6px 2px!important}}';
  var pogingen = 0, klok = setInterval(function () {
    var host = document.querySelector('csm-cookie-consent'), laag = host && host.shadowRoot;
    if (laag) {
      var stijl = document.createElement('style');
      stijl.setAttribute('data-wootz', '');
      stijl.textContent = css;
      laag.appendChild(stijl);
    }
    if (laag || ++pogingen > 100) clearInterval(klok);
  }, 300);
})();
